import { accent, fontSize, neutral, primaryAction, radius, text } from 'styles/revampTokens';

/**
 * The app theme paints the page body and the default button white. Task
 * screens are light, so a field or button that does not set its own colour
 * disappears into that background.
 */
export const taskFieldProperties = {
  bg: neutral.surface,
  color: text.primary,
  borderColor: neutral.border,
  borderRadius: radius.control,
  fontSize: fontSize.body,
  _placeholder: { color: text.muted },
  _hover: { borderColor: neutral.borderStrong },
  _focus: {
    borderColor: accent.solid,
    boxShadow: `0 0 0 1px ${accent.solid}`,
    color: text.primary,
  },
  _disabled: { color: text.secondary, opacity: 1 },
  _readOnly: { color: text.primary },
  sx: { colorScheme: 'light' },
};

const taskButtonBase = {
  // `unstyled` drops the theme default, which is white text on a transparent button.
  variant: 'unstyled' as const,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  h: '32px',
  px: '12px',
  lineHeight: '1.2',
  borderRadius: radius.control,
  fontSize: fontSize.body,
  fontWeight: 500,
};

export const taskQuietButtonProperties = {
  ...taskButtonBase,
  bg: 'transparent',
  color: text.primary,
  _hover: { bg: neutral.surfaceHover, color: text.primary },
  _active: { bg: neutral.surfaceHover, color: text.primary },
};

export const taskOutlineButtonProperties = {
  ...taskButtonBase,
  bg: neutral.surface,
  color: text.primary,
  border: '1px solid',
  borderColor: neutral.border,
  _hover: { bg: neutral.surfaceHover, color: text.primary, borderColor: neutral.borderStrong },
  _active: { bg: neutral.surfaceHover, color: text.primary },
};

export const taskPrimaryButtonProperties = {
  ...taskButtonBase,
  bg: primaryAction.bg,
  color: text.inverse,
  _hover: { bg: primaryAction.hover, color: text.inverse },
  _active: { bg: primaryAction.hover, color: text.inverse },
  _disabled: { bg: primaryAction.bg, color: text.inverse, opacity: 0.45 },
};
